<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
    <!-- INDICADORES -->
    <div class="row">
      <div class="col-md-4">
        <b-card class="heightCardHeader">
          <b-card-title>Consultar</b-card-title>
          <div>
            <b-form-group
              :state="state('mesReferencia')"
              label="Ano Referência"
              invalid-feedback="campo obrigatório"
              class="col-md-12"
            >
              <multiselect
                v-model="dadosConsulta.selectedAno"
                placeholder="Selecione"
                :show-labels="false"
                :options="dadosConsulta.optionAno"
                :allow-empty="false"
                :max-height="150"
                @input="inputAno"
              />
            </b-form-group>
            <b-form-group
              :state="state('projeto')"
              label="Mês Referência"
              invalid-feedback="campo obrigatório"
              class="col-md-12 mb-3"
            >
              <multiselect
                v-model="dadosConsulta.selectedMes"
                placeholder="Selecione"
                :show-labels="false"
                :options="dadosConsulta.optionMes"
                :allow-empty="false"
                :custom-label="
                  (el) => $tools.mesesDoAno(parseInt(el.substr(0, 2)))
                "
              />
            </b-form-group>
          </div>

          <div class="row">
            <div class="col-4 mt-1">
              <!-- <b-button variant="light" @click="iniciarTour()" class="mt-1">
                  <i class="mdi mdi-help-circle font-size-16 align-middle me-2"></i>
                  Ajuda
                </b-button> -->
            </div>
            <div class="col-8 mt-1 d-flex justify-content-end">
              <b-button @click="limparPesquisa()" class="mt-1 me-1">
                <i class="mdi mdi-broom font-size-16 align-middle me-1"></i>
                Limpar
              </b-button>
              <b-button variant="primary" @click="filtrarItem()" class="mt-1">
                <i
                  class="mdi mdi-filter-outline font-size-16 align-middle me-1"
                ></i>
                Filtrar
              </b-button>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-4" v-if="viewGraficos">
        <b-card class="heightCardHeader">
          <b-card-title>Indicadores</b-card-title>
          <div class="row">
            <div class="col-md-6">
              <div class="card shadow-none border">
                <div class="card-body p-2">
                  <div>
                    <h5 class="text-center text-blue fs-3">
                      {{ indicadores.tomadores }}
                    </h5>
                  </div>
                </div>
                <h6 class="text-center">Tomadores</h6>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card shadow-none border">
                <div class="card-body p-2">
                  <div>
                    <h5 class="text-center text-blue fs-3">
                      {{ indicadores.numeroFolhas }}
                    </h5>
                  </div>
                </div>
                <h6 class="text-center">N° Folhas</h6>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card shadow-none border">
                <div class="card-body p-2">
                  <div>
                    <h5 class="text-center text-blue fs-3">
                      {{ $tools.converteReal(indicadores.valorTotal) }}
                    </h5>
                  </div>
                </div>
                <h6 class="text-center">Valor Líquido Total</h6>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card shadow-none border">
                <div class="card-body p-2">
                  <div>
                    <h3 class="text-center text-blue fs-3">
                      {{ dataCredito }}
                    </h3>
                  </div>
                </div>
                <h6 class="text-center">Data Crédito</h6>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-4" v-if="viewGraficos">
        <b-card class="heightCardHeader">
          <b-card-title>Totais por Tipos de Itens </b-card-title>
          <div class="row" v-if="graficoItens">
            <apexchart
              height="240"
              class="apex-color"
              type="pie"
              :series="graficoItens.series"
              :options="graficoItens.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </div>
    </div>
    <!-- TABELA -->
    <div class="row">
      <div class="d-flex justify-content-center" v-if="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
      <div class="col-md-12" v-if="viewGraficos">
        <b-card class="heightCardHeader">
          <b-card-title>Listagem de Folha de Produção</b-card-title>
          <b-table
            responsive="sm"
            :fields="camposFolhaProdutor"
            :items="tabelaFolhaProdutor"
            :per-page="perPage"
            :current-page="currentPage"
            striped
          >
            <template v-slot:cell(projeto)="data">
              {{ data.item.projeto }} - [{{ data.item.cd_folha }}]
            </template>
            <template v-slot:cell(actions)="data">
              <div class="align-self-center mt-1 text-end">
                <b-button
                  class="m-1"
                  variant="primary"
                  @click="downloadDemonstrativo(data.item)"
                  :disabled="loadingDownload"
                >
                  <i class="mdi mdi-download" />
                  <b-spinner
                    small
                    class="ms-2"
                    v-if="loadingDownload"
                  ></b-spinner>
                </b-button>
                <b-button
                  class="m-1"
                  variant="primary"
                  @click="htmlOnline(data.item.cd_projeto)"
                >
                  <i class="mdi mdi-eye" />
                </b-button>
              </div>
            </template>
            <template v-slot:cell(vl_liquido)="data">
              {{
                $tools.converteReal(data.item.proventos - data.item.descontos)
              }}
            </template>
          </b-table>
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="(rows = tabelaFolhaProdutor.length)"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </b-card>
      </div>
    </div>
    <!-- GRAFICOS -->
    <div class="row" v-if="viewGraficos">
      <div class="col-md-6" v-if="graficoCreditos">
        <b-card class="heightCardHeader">
          <b-card-title>
            {{ graficoCreditos.nameChart }}
          </b-card-title>
          <apexchart
            class="apex-color"
            height="350"
            type="bar"
            :series="graficoCreditos.series"
            :options="graficoCreditos.chartOptions"
          ></apexchart>
        </b-card>
      </div>
      <div class="col-md-6" v-if="graficoImpostos">
        <b-card class="heightCardHeader">
          <b-card-title>
            {{ graficoImpostos.nameChart }}
          </b-card-title>
          <apexchart
            class="apex-color"
            height="350"
            type="bar"
            :series="graficoImpostos.series"
            :options="graficoImpostos.chartOptions"
          ></apexchart>
        </b-card>
      </div>
    </div>
    <div class="row" v-if="viewGraficos">
      <div class="col-md-6" v-if="graficoTaxaRetencao">
        <b-card class="heightCardHeader">
          <b-card-title>
            {{ graficoTaxaRetencao.nameChart }}
          </b-card-title>
          <apexchart
            class="apex-color"
            height="350"
            type="bar"
            :series="graficoTaxaRetencao.series"
            :options="graficoTaxaRetencao.chartOptions"
          ></apexchart>
        </b-card>
      </div>
      <div class="col-md-6" v-if="graficoDescontos">
        <b-card class="heightCardHeader">
          <b-card-title>
            {{ graficoDescontos.nameChart }}
          </b-card-title>
          <apexchart
            class="apex-color"
            height="350"
            type="bar"
            :series="graficoDescontos.series"
            :options="graficoDescontos.chartOptions"
          ></apexchart>
        </b-card>
      </div>
    </div>
    <div class="row" v-if="viewGraficos">
      <div class="col-md-6" v-if="graficoOutros">
        <b-card class="heightCardHeader">
          <b-card-title>
            {{ graficoOutros.nameChart }}
          </b-card-title>
          <apexchart
            class="apex-color"
            height="350"
            type="bar"
            :series="graficoOutros.series"
            :options="graficoOutros.chartOptions"
          ></apexchart>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import folhaProducaoMixin from "@/tools/mixins/folhaProducaoMixin";
import { graficoItens, graficoCategorias } from "./data-apex";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  mixins: [folhaProducaoMixin],
  data() {
    return {
      title: "Gestão da Folha de Produção",
      items: [
        {
          text: "Gestão da Folha de Produção",
        },
      ],
      dados: {
        mesReferencia: "",
        projeto: "",
      },
      proventos: [],
      impostos: [],
      descontos: [],
      outros: [],
      graficoItens: {},
      graficoCreditos: {},
      graficoImpostos: {},
      graficoDescontos: {},
      graficoOutros: {},
      graficoTaxaRetencao: {},
      perPage: 3,
      currentPage: 1,
      rows: 0,
      camposFolhaProdutor: [
        {
          key: "nm_projeto",
          label: "Projeto",
        },
        {
          key: "vl_creditos",
          label: "Créditos Totais",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          class: "alinharCelulaDireita",
        },
        {
          key: "vl_debitos",
          label: "Débitos Totais",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          class: "alinharCelulaDireita",
        },
        {
          key: "vl_total",
          label: "Valor Líquido Total",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          class: "alinharCelulaDireita",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      tabelaFolhaProdutor: [],
      dadosConsulta: {
        optionAno: [],
        selectedAno: "",
        optionMes: [],
        selectedMes: "",
      },
      cabecalho: [],
      indicadores: {
        tomadores: 0,
        numeroFolhas: 0,
        valorTotal: 0,
        dataCredito: 0,
      },
      loading: false,
      viewGraficos: false,
      loadingDownload: false,
    };
  },
  async mounted() {
    await this.filtrarCabecalho();
  },
  computed: {
    dataCredito() {
      if (this.indicadores.dataCredito) {
        return this.$tools.converteData(this.indicadores.dataCredito);
      } else {
        return 0;
      }
    },
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    async filtrarCabecalho() {
      this.dadosConsulta.optionAno = [];
      try {
        this.cabecalho = await this.buscarCabecalho();
        if (this.cabecalho) {
          this.cabecalho.forEach((el) => {
            if (!this.dadosConsulta.optionAno.includes(el.ano_referencia)) {
              this.dadosConsulta.optionAno.push(el.ano_referencia);
            }
          });
          this.dadosConsulta.optionAno = this.dadosConsulta.optionAno.sort(
            (a, b) => {
              return b - a;
            }
          );
        }
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }

      this.loading = false;
    },
    async filtrarItem() {
      this.viewGraficos = false;
      this.currentPage = 1;
      this.loading = true;
      let folhas = this.filtrarIndicadores();
      try {
        let item = await this.buscarItem(folhas);
        this.graficoItens = graficoItens(item);
        this.filtrarTabela(item);
        this.graficoCreditos = graficoCategorias(item, 1);
        this.graficoImpostos = graficoCategorias(item, 2);
        this.graficoDescontos = graficoCategorias(item, 3);
        this.graficoOutros = graficoCategorias(item, 4);
        this.graficoTaxaRetencao = graficoCategorias(item, 5);
        this.loading = false;
        this.viewGraficos = true;
      } catch (err) {
        // this.$tools.alerta(err.response.data.message, "error");
        this.loading = false;
      }
      this.$tools.fecharMenu();
    },
    inputAno() {
      this.dadosConsulta.optionMes = [];
      this.cabecalho.forEach((el) => {
        if (el.ano_referencia == this.dadosConsulta.selectedAno) {
          if (!this.dadosConsulta.optionMes.includes(el.mes_referencia)) {
            this.dadosConsulta.optionMes.push(el.mes_referencia);
          }
        }
      });
      this.dadosConsulta.optionMes = this.dadosConsulta.optionMes.sort(
        (a, b) => {
          return parseInt(b.substr(0, 2)) - parseInt(a.substr(0, 2));
        }
      );
    },
    filtrarIndicadores() {
      let tomadores = [];
      let valorTotal = 0;
      let sqFolhas = "";
      let indicadoresArray = [];
      this.cabecalho.forEach((el) => {
        if (
          el.ano_referencia == this.dadosConsulta.selectedAno &&
          el.mes_referencia == this.dadosConsulta.selectedMes
        ) {
          indicadoresArray.push(el);
        }
      });
      indicadoresArray.forEach((el) => {
        if (!tomadores.includes(el.cd_tomador)) {
          tomadores.push(el.cd_tomador);
        }
        valorTotal += parseFloat(el.vl_liquido);
        sqFolhas += el.sq_folha + ",";
      });
      this.indicadores.tomadores = tomadores.length;
      this.indicadores.valorTotal = valorTotal;
      this.indicadores.dataCredito = indicadoresArray[0].dt_credito;
      this.indicadores.numeroFolhas = indicadoresArray.length;
      return sqFolhas.substr(0, sqFolhas.length - 1);
    },
    filtrarTabela(folhaItem) {
      this.tabelaFolhaProdutor = [];
      let cdProjeto = [];
      let folhaAux = {};
      folhaItem.forEach((el) => {
        if (!cdProjeto.includes(el.cd_projeto)) {
          cdProjeto.push(el.cd_projeto);
          folhaAux = el;
          folhaAux.vl_creditos = 0;
          folhaAux.vl_debitos = 0;
          folhaAux.vl_total = 0;
          folhaItem.forEach((item) => {
            if (item.cd_projeto == el.cd_projeto) {
              switch (parseInt(item.sq_categoria_item_folha)) {
                case 1:
                  folhaAux.vl_creditos += parseFloat(item.vl_lcto);
                  break;
                case 2:
                  folhaAux.vl_debitos += parseFloat(item.vl_lcto);
                  break;
                case 3:
                  folhaAux.vl_debitos += parseFloat(item.vl_lcto);
                  break;
                case 4:
                  folhaAux.vl_creditos += parseFloat(item.vl_lcto);
                  break;
                case 5:
                  folhaAux.vl_debitos += parseFloat(item.vl_lcto);
                  break;
              }
            }
          });
          folhaAux.vl_total = folhaAux.vl_creditos - folhaAux.vl_debitos;
          this.tabelaFolhaProdutor.push(folhaAux);
        }
      });
    },
    limparPesquisa() {
      this.viewGraficos = false;
    },
    htmlOnline(cdProjeto) {
      let objEnvio =
        cdProjeto + "-" + this.dadosConsulta.selectedMes.replace("/", "-");
      window.open("folhaProducao/" + objEnvio);
      // this.$router.push({ path: 'folhaProducao/' + objEnvio
      // });
    },
    downloadDemonstrativo(item) {
      this.loadingDownload = true;
      this.$http
        .post("api/folhaProducao/downloadDemonstrativo", {
          cd_projeto: item.cd_projeto,
          mes_referencia: item.mes_referencia.substr(0, 2),
          ano_referencia: item.ano_referencia,
        })
        .then((response) => {
          this.loadingDownload = false;
          if (!response.data.base64) {
            return this.$tools.alerta("Erro ao gerar relatorio", "error");
          }
          var blob = this.$tools.base64toBlob(
            response.data.base64,
            "application/pdf"
          );

          var url = window.URL.createObjectURL(blob);

          var link = document.createElement("a");
          var data = new Date();
          link.href = url;
          link.download =
            "Demonstrativo-Producao-" +
            data.getDate() +
            "-" +
            data.getMonth() +
            "-" +
            data.getFullYear() +
            ".pdf";
          link.click();

          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.loadingDownload = false;
          console.log(err);
        });
    },
  },
};
</script>
<style >
.apex-color {
  min-height: 10px !important;
}
.apex-color text {
  fill: #495057;
}
.apex-color .apexcolor-canvas {
  margin: 0 auto;
}
</style>